"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const StatusIndicator_1 = require("../../styled/StatusIndicator");
exports.TableSort = ({ onSortChange, sortOptions, value, }) => {
    const onChange = (value) => {
        const option = sortOptions.find((v) => v.value === value);
        option && onSortChange && onSortChange(option);
    };
    const sortValue = value || sortOptions[0];
    return (react_1.default.createElement(StatusIndicator_1.StyledCustomDropDown, { disabled: !Boolean(sortOptions.length), icon: "fa fa-sort-amount-up-alt master-tc-sort test-sort-button", onChange: onChange, value: sortValue === null || sortValue === void 0 ? void 0 : sortValue.value, options: sortOptions || [], name: "table-sort", right: true }));
};
//# sourceMappingURL=TableSort.js.map